namespace RioERP.Reports {
    export interface OrderCombinedReportForm {
        OrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        SourceType: Serenity.EnumEditor;
        SourceOrderNumber: Serenity.StringEditor;
        FranchiseeName: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductSpecificationName: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Address1: Serenity.StringEditor;
        Address2: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        PinCode: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EOrderStatus: Serenity.IntegerEditor;
        PaymentStatus: Serenity.IntegerEditor;
        EPaymentType: Serenity.IntegerEditor;
        DiscountCoupen: Serenity.StringEditor;
        TaxableAmount: Serenity.DecimalEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmountNet: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class OrderCombinedReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderCombinedReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderCombinedReportForm.init)  {
                OrderCombinedReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.EnumEditor;
                var w3 = s.StringEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(OrderCombinedReportForm, [
                    'OrderId', w0,
                    'OrderDate', w1,
                    'SourceType', w2,
                    'SourceOrderNumber', w3,
                    'FranchiseeName', w3,
                    'CustomerName', w3,
                    'CustomerMobile1', w3,
                    'CustomerEmail1', w3,
                    'ProductName', w3,
                    'ProductSpecificationName', w3,
                    'City', w3,
                    'Address1', w3,
                    'Address2', w3,
                    'StateName', w3,
                    'PinCode', w3,
                    'ShippingAddress1', w3,
                    'ShippingAddress2', w3,
                    'ShippingCity', w3,
                    'ShippingPincode', w0,
                    'EOrderStatus', w0,
                    'PaymentStatus', w0,
                    'EPaymentType', w0,
                    'DiscountCoupen', w3,
                    'TaxableAmount', w4,
                    'Total', w4,
                    'DiscountAmount', w4,
                    'NetAmount', w4,
                    'TaxableAmountNet', w4,
                    'CgstRate', w4,
                    'CgstAmount', w4,
                    'SgstRate', w4,
                    'SgstAmount', w4,
                    'IgstRate', w4,
                    'IgstAmount', w4,
                    'TotalTax', w4
                ]);
            }
        }
    }
}
